//----------------------
// <auto-generated>
//     Generated using Aya Client Generator [Version 1.0.2]
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AcceptanceCriteriaStatus } from './enums/acceptance-criteria-status.enum';
import { AcceptanceCriteriaType } from './enums/acceptance-criteria-type.enum';
import { DocumentTypeLevelType } from './enums/document-type-level-type.enum';
import { SortDirectionEnum } from './enums/sort-direction-enum.enum';
import { API_BASE_URL } from './misc/api-base-url.token';
import { blobToText } from './misc/blob-to-text.function';
import { FileParameter } from './misc/file-parameter.model';
import { FileResponse } from './misc/file-response.model';
import { throwException } from './misc/throw-exception.function';
import { AvailableStatesDto } from './models/available-states-dto.model';
import { ProfileRequirementsDto } from './models/profile-requirements-dto.model';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class StateRequirementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAvailableStates(filter_StateId: number | undefined, filter_StateName: string | null | undefined, filter_StateCode: string | null | undefined, pageSize: number | undefined, skip: number | undefined, sort_Field: string | null | undefined, sort_Type: SortDirectionEnum | undefined, paginated: boolean | undefined): Observable<AvailableStatesDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/state-requirements/available-states?";
        if (filter_StateId === null)
            throw new Error("The parameter 'filter_StateId' cannot be null.");
        else if (filter_StateId !== undefined)
            url_ += "Filter.StateId=" + encodeURIComponent("" + filter_StateId) + "&";
        if (filter_StateName !== undefined && filter_StateName !== null)
            url_ += "Filter.StateName=" + encodeURIComponent("" + filter_StateName) + "&";
        if (filter_StateCode !== undefined && filter_StateCode !== null)
            url_ += "Filter.StateCode=" + encodeURIComponent("" + filter_StateCode) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (sort_Field !== undefined && sort_Field !== null)
            url_ += "Sort.Field=" + encodeURIComponent("" + sort_Field) + "&";
        if (sort_Type === null)
            throw new Error("The parameter 'sort_Type' cannot be null.");
        else if (sort_Type !== undefined)
            url_ += "Sort.Type=" + encodeURIComponent("" + sort_Type) + "&";
        if (paginated === null)
            throw new Error("The parameter 'paginated' cannot be null.");
        else if (paginated !== undefined)
            url_ += "Paginated=" + encodeURIComponent("" + paginated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableStates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvailableStatesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvailableStatesDto[]>;
        }));
    }

    protected processGetAvailableStates(response: HttpResponseBase): Observable<AvailableStatesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AvailableStatesDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStateGlobalRequirements(stateId: number, filter_RequirementId: number | null | undefined, filter_RequirementName: string | null | undefined, filter_TaskType: number[] | null | undefined, filter_ClientPortalVisibility: boolean | null | undefined, filter_RequirementLevel: DocumentTypeLevelType[] | null | undefined, filter_QualificationSettingsLevel: DocumentTypeLevelType[] | null | undefined, filter_LinesOfBusiness: number[] | null | undefined, filter_IsDefault: boolean | null | undefined, filter_ExpirationRequired: boolean | null | undefined, filter_RequirementDescription: DocumentTypeLevelType[] | null | undefined, filter_ExternalRequirementDescription: DocumentTypeLevelType[] | null | undefined, filter_CategoryLineOfBusinessId: number[] | null | undefined, filter_AcceptanceCriteriaType: AcceptanceCriteriaType[] | null | undefined, filter_AcceptanceCriteriaStatus: AcceptanceCriteriaStatus[] | null | undefined, pageSize: number | undefined, skip: number | undefined, sort_Field: string | null | undefined, sort_Type: SortDirectionEnum | undefined, paginated: boolean | undefined): Observable<ProfileRequirementsDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/state-requirements/{stateId}/requirements?";
        if (stateId === undefined || stateId === null)
            throw new Error("The parameter 'stateId' must be defined.");
        url_ = url_.replace("{stateId}", encodeURIComponent("" + stateId));
        if (filter_RequirementId !== undefined && filter_RequirementId !== null)
            url_ += "Filter.RequirementId=" + encodeURIComponent("" + filter_RequirementId) + "&";
        if (filter_RequirementName !== undefined && filter_RequirementName !== null)
            url_ += "Filter.RequirementName=" + encodeURIComponent("" + filter_RequirementName) + "&";
        if (filter_TaskType !== undefined && filter_TaskType !== null)
            filter_TaskType && filter_TaskType.forEach(item => { url_ += "Filter.TaskType=" + encodeURIComponent("" + item) + "&"; });
        if (filter_ClientPortalVisibility !== undefined && filter_ClientPortalVisibility !== null)
            url_ += "Filter.ClientPortalVisibility=" + encodeURIComponent("" + filter_ClientPortalVisibility) + "&";
        if (filter_RequirementLevel !== undefined && filter_RequirementLevel !== null)
            filter_RequirementLevel && filter_RequirementLevel.forEach(item => { url_ += "Filter.RequirementLevel=" + encodeURIComponent("" + item) + "&"; });
        if (filter_QualificationSettingsLevel !== undefined && filter_QualificationSettingsLevel !== null)
            filter_QualificationSettingsLevel && filter_QualificationSettingsLevel.forEach(item => { url_ += "Filter.QualificationSettingsLevel=" + encodeURIComponent("" + item) + "&"; });
        if (filter_LinesOfBusiness !== undefined && filter_LinesOfBusiness !== null)
            filter_LinesOfBusiness && filter_LinesOfBusiness.forEach(item => { url_ += "Filter.LinesOfBusiness=" + encodeURIComponent("" + item) + "&"; });
        if (filter_IsDefault !== undefined && filter_IsDefault !== null)
            url_ += "Filter.IsDefault=" + encodeURIComponent("" + filter_IsDefault) + "&";
        if (filter_ExpirationRequired !== undefined && filter_ExpirationRequired !== null)
            url_ += "Filter.ExpirationRequired=" + encodeURIComponent("" + filter_ExpirationRequired) + "&";
        if (filter_RequirementDescription !== undefined && filter_RequirementDescription !== null)
            filter_RequirementDescription && filter_RequirementDescription.forEach(item => { url_ += "Filter.RequirementDescription=" + encodeURIComponent("" + item) + "&"; });
        if (filter_ExternalRequirementDescription !== undefined && filter_ExternalRequirementDescription !== null)
            filter_ExternalRequirementDescription && filter_ExternalRequirementDescription.forEach(item => { url_ += "Filter.ExternalRequirementDescription=" + encodeURIComponent("" + item) + "&"; });
        if (filter_CategoryLineOfBusinessId !== undefined && filter_CategoryLineOfBusinessId !== null)
            filter_CategoryLineOfBusinessId && filter_CategoryLineOfBusinessId.forEach(item => { url_ += "Filter.CategoryLineOfBusinessId=" + encodeURIComponent("" + item) + "&"; });
        if (filter_AcceptanceCriteriaType !== undefined && filter_AcceptanceCriteriaType !== null)
            filter_AcceptanceCriteriaType && filter_AcceptanceCriteriaType.forEach(item => { url_ += "Filter.AcceptanceCriteriaType=" + encodeURIComponent("" + item) + "&"; });
        if (filter_AcceptanceCriteriaStatus !== undefined && filter_AcceptanceCriteriaStatus !== null)
            filter_AcceptanceCriteriaStatus && filter_AcceptanceCriteriaStatus.forEach(item => { url_ += "Filter.AcceptanceCriteriaStatus=" + encodeURIComponent("" + item) + "&"; });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (sort_Field !== undefined && sort_Field !== null)
            url_ += "Sort.Field=" + encodeURIComponent("" + sort_Field) + "&";
        if (sort_Type === null)
            throw new Error("The parameter 'sort_Type' cannot be null.");
        else if (sort_Type !== undefined)
            url_ += "Sort.Type=" + encodeURIComponent("" + sort_Type) + "&";
        if (paginated === null)
            throw new Error("The parameter 'paginated' cannot be null.");
        else if (paginated !== undefined)
            url_ += "Paginated=" + encodeURIComponent("" + paginated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStateGlobalRequirements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStateGlobalRequirements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileRequirementsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileRequirementsDto[]>;
        }));
    }

    protected processGetStateGlobalRequirements(response: HttpResponseBase): Observable<ProfileRequirementsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileRequirementsDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}